import { Role } from "@cryptors/api-client";
import { z } from "zod";

const citySelectionSchema = z.union([z.number(), z.object({ id: z.number() })]);

export const userFormSchema = z.object({
  pseudo: z.string().min(3).nullable(),
  email: z.string().email().nullable(),
  password: z.string().optional(),
  emailConfirmed: z.boolean().default(false),
  role: z.nativeEnum(Role),
  avatarId: z.number().int().positive().default(1),
  cryptorsDraftAccess: z.array(
    z.union([z.number(), z.object({ id: z.number() })]),
  ),
  isTesterAccount: z.boolean(),
  allowedCities: z.array(citySelectionSchema).optional(),
  logoUrl: z.string().nullable().optional(),
});

export type UserFormValues = z.infer<typeof userFormSchema>;
